var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgChannels = function SvgChannels(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12 3c.33 0 .6.263.6.588a.592.592 0 0 1-.503.58l-.097.008H3.48a1.271 1.271 0 0 0-1.274 1.119l-.006.127-.001 1.603.13-.074c.235-.123.489-.208.751-.25l.199-.025.2-.01h9.401c1.311.002 2.386.997 2.474 2.257l.006.166v.688l3.342-2.345a1.58 1.58 0 0 1 1.266-.113l.152.06.147.078c.411.245.678.663.725 1.125l.008.156v8.034a1.488 1.488 0 0 1-.73 1.28 1.558 1.558 0 0 1-1.365.122l-.15-.066-3.396-2.377v.692c0 1.226-.933 2.238-2.143 2.399l-.166.016-.17.006h-9.4c-1.311-.001-2.385-.996-2.474-2.256L1 16.422v-11c.002-1.282 1.021-2.33 2.31-2.416L3.48 3h5.64zm3.76 4.843h-9.4c-.663.001-1.207.491-1.274 1.118L2.2 9.09v7.333c0 .644.503 1.175 1.149 1.24l.13.006h9.4c.664-.001 1.208-.491 1.274-1.118l.007-.128V9.09c0-.687-.573-1.245-1.28-1.246zm6.598.565-.081.004-.072.022-3.966 2.79v3.061l3.989 2.81c.08.021.165.015.24-.017l.07-.04a.345.345 0 0 0 .132-.19l.01-.076V8.738a.326.326 0 0 0-.16-.279.366.366 0 0 0-.162-.05z",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
};

export default SvgChannels;